import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sounds/request_forward.mp3")